// third-party

// assets
import {
  LineChartOutlined,
  IdcardOutlined,
  DatabaseOutlined,
  BuildOutlined,
  CalendarOutlined,
  CustomerServiceOutlined,
  MessageOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  AppstoreAddOutlined,
  FileTextOutlined
} from '@ant-design/icons';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  BuildOutlined,
  CalendarOutlined,
  CustomerServiceOutlined,
  MessageOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  AppstoreAddOutlined,
  FileTextOutlined,
  LineChartOutlined,
  IdcardOutlined,
  DatabaseOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const Information: NavItemType = {
  id: 'group-information',
  title: 'Information',
  icon: icons.IdcardOutlined,
  type: 'group',
  children: [
    {
      id: 'information-assets',
      title: 'Assets',
      type: 'collapse',
      url: '/information/asset/',
      icon: icons.FileTextOutlined,
      breadcrumbs: true,
      children: [
        {
          id: 'information-karachaganak',
          title: 'Karachaganak',
          type: 'item',
          url: '/information/asset/Karachaganak'
        },
        {
          id: 'information-tengiz',
          title: 'Tengiz',
          type: 'item',
          url: '/information/asset/Tengiz'
        },
        {
          id: 'information-kashagan',
          title: 'Kashagan',
          type: 'item',
          url: '/information/asset/Kashagan'
        },
        {
          id: 'information-kalamkas-offshore',
          title: 'Kalamkas offshore',
          type: 'item',
          url: '/information/asset/Kalamkas-offshore'
        }
      ]
    }
  ]
};

export default Information;
